import { useMutation, useQueryClient } from '@tanstack/react-query';
import axiosInstance from '../../axiosConfig';

const resetPreferences = async () => {
  const { data } = await axiosInstance.delete(
    '/notifications/preferences/reset/'
  );
  return data;
};

export const useResetPreferences = (options = {}) => {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: resetPreferences,
    onSuccess: (data, vars) => {
      queryClient.invalidateQueries({
        queryKey: ['notifications', 'preferences'],
      });
      options.onSuccess?.(data, vars);
    },
    onError: options.onError,
  });
  return { resetPreferences: mutation.mutateAsync, ...mutation };
};
